import React from 'react'
import { CaptionText } from '@paypalcorp/pp-react'

import { Tag } from '../../types/ShoppingPageType'
import useBreakpoint from '../../../../lib/useBreakpoint'
import { AUTOMATION_LOCATORS } from '../../constants/automation'

interface Props {
  tags: Tag[] | null
  isInverse?: boolean
}

const Tags = ({ tags, isInverse = false }: Props) => {
  const { isMobile } = useBreakpoint()
  if (!tags || !tags.length) return null
  tags = isMobile ? tags.slice(0, 2) : tags

  let className = 'tags--v2__caption'
  className = isInverse ? `${className}--inverse` : className

  const labels = tags.map(tag => {
    return (
      <CaptionText
        data-cy={AUTOMATION_LOCATORS.TAG_ITEM}
        key={tag.type}
        className={className}
      >
        {tag.text}
      </CaptionText>
    )
  })

  return (
    <div className="tags--v2" data-cy={AUTOMATION_LOCATORS.TAGS}>
      {labels}
    </div>
  )
}

export default Tags
